import React, { useState, useEffect } from 'react'
import moment, { duration } from 'moment'
import SAISVG from '../../../../../../_template/helpers/CommonFunction';

const TableRow = (props) => {
    const openDrawer = () => {
        const data = {
            room: props.row.room,
            duration: props.row.duration
        }
        props.onChatButtonClick(data);
    }

    return (
        <tr key={props.index}>
            <td className='w-80px min-w-80px'>
                <div className="row">
                    <div className="d-flex justify-content-center flex-column">
                        <a className="btn btn-sm btn-icon btn-light-dark me-3 px-4" onClick={openDrawer}>
                            <SAISVG path="media/icons/duotune/communication/com003.svg" className="svg-icon-muted svg-icon-2" />
                        </a>
                    </div>
                </div>
            </td>
            <td className="w-150px min-w-100px">
                <div className='row'>
                    <div className="d-flex flex-column">
                        <span className="text-gray-800 fw-semibold d-block fs-7">
                            {props.row.bot_name}
                        </span>
                    </div>
                </div>
            </td>
            <td className="w-150px min-w-100px">
                <div className='row'>
                    <div className="d-flex flex-column">
                        <span className="text-gray-800 fw-semibold d-block fs-7">
                            {moment(props.row.created_at).format("D MMM YYYY, H:mm")}
                        </span>
                    </div>
                </div>
            </td>
            <td className="w-150px min-w-100px">
                <div className='row'>
                    <div className="d-flex flex-column">
                        <span className="text-gray-800 fw-semibold d-block fs-7">
                            {moment(props.row.updated_at).format("D MMM YYYY, H:mm")}
                        </span>
                    </div>
                </div>
            </td>
            <td className="w-150px min-w-100px">
                <div className='row'>
                    <div className="d-flex flex-column">
                        <span className="text-gray-800 fw-semibold d-block fs-7">
                            {props.row.duration}
                        </span>
                    </div>
                </div>
            </td>
            <td className="w-80px min-w-80px">
                <div className='row'>
                    <div className="d-flex flex-column">
                        <span className="text-gray-800 fw-semibold d-block fs-7">
                            {props.row.total_dialog}
                        </span>
                    </div>
                </div>
            </td>
            {/* <td className='w-250px min-w-150px'>
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Started On
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {moment(props.row.created_at).format("D MMM YYYY, H:mm")}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-12 mb-2">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Duration
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {props.row.duration}
                            </span>
                        </div>
                    </div>
                </div>
            </td> */}
            <td className='w-250px min-w-100px'>
                <div className="row">
                    <div className="col-md-12 mb-2">
                        <div className="d-flex justify-content-start flex-column">
                            <span className="text-gray-600 fw-semibold d-block fs-7">
                                {props.row.user_source}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <span className="badge badge-light-success">
                            {props.row.unique_ip === "yes" ? "Unique" : ""}
                        </span>
                    </div>
                </div>
            </td>
            {/* <td>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.routing}
                            </a>
                        </div>
                    </div>
                </div>
            </td> */}
            <td className='w-250px min-w-200px'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.name}
                            </a>
                            <span>
                                <div className="badge badge-light-dark fw-bold">
                                    {props.row.mobile_number}
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </td>
            <td className='w-250px min-w-100px'>
                <div className='row'>
                    {/* <div className='col-md-12'>
                        <span className="me-2">
                            <div className="badge badge-light fw-bold mb-1">
                                Product 1
                            </div>
                        </span>
                        <span className="me-2">
                            <div className="badge badge-light fw-bold mb-1">
                                Product 2
                            </div>
                        </span>
                    </div> */}
                </div>
            </td>
            <td className='w-250px min-w-100px'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.status}
                            </a>
                        </div>
                    </div>
                </div>
            </td>
            {/* <td>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.intent}
                            </a>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.entity}
                            </a>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.information}
                            </a>
                        </div>
                    </div>
                </div>
            </td> */}
            <td className='w-250px min-w-100px'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.feedback}
                            </a>
                        </div>
                    </div>
                </div>
            </td>
            {/* <td>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column">
                            <a className="text-gray-800  mb-1">
                                {props.row.external_action}
                            </a>
                        </div>
                    </div>
                </div>
            </td> */}
            <td className='w-250px min-w-200px'>
                <div className="row">
                    <div className="col-md-12 mb-2">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Handover
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {props.row.transfer_by}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="d-flex justify-content-start flex-column">
                            <a className="text-gray-600 fw-bold fs-6">
                                Transfer On
                            </a>
                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                {props.row.transfer_on ? moment(props.row.transfer_on).format("D MMM YYYY, H:mm"):''}
                            </span>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    )
}

export default TableRow;